import { Types } from "../prop-controllers";
import { responsiveNumberValueSchema } from "../data";
import { versionedPropDef, typeArg } from "../versioned";
const ResponsiveNumber = versionedPropDef(
  Types.ResponsiveNumber,
  responsiveNumberValueSchema,
  {
    version: 1,
    dataKey: "prop-controllers::responsive-number::v1"
  },
  typeArg()
);
export {
  ResponsiveNumber
};
//# sourceMappingURL=responsive-number.js.map